import './styles/features.css'
import feature1 from '../assets/icons/feature1.svg'
import feature2 from '../assets/icons/feature2.svg'
import feature3 from '../assets/icons/feature3.svg'
import feature4 from '../assets/icons/feature4.svg'
import feature5 from '../assets/icons/feature5.svg'
import feature6 from '../assets/icons/feature6.svg'

const cards = [
    {
        icon:feature1,
        title:'Feature 1',
        text:`
        Lorem ipsum dolor sit amet consectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit. ectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit.`
    },
    {
        icon:feature2,
        title:'Feature 2',
        text:`
        Lorem ipsum dolor sit amet consectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit. ectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit.`
    },
    {
        icon:feature3,
        title:'Feature 3',
        text:`
        Lorem ipsum dolor sit amet consectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit. ectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit.`
    },
    {
        icon:feature4,
        title:'Feature 4',
        text:`
        Lorem ipsum dolor sit amet consectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit. ectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit.`
    },
    {
        icon:feature5,
        title:'Feature 5',
        text:`
        Lorem ipsum dolor sit amet consectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit. ectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit.`
    },
    {
        icon:feature6,
        title:'Feature 6',
        text:`
        Lorem ipsum dolor sit amet consectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit. ectetur adipiscing elit 
        Ut et massa mi. Aliquam in hendrerit.`
    },
]

export default function Features() {
  return (
    <div id='features' className='features'>
      <div className='container'>
        <div className="features__title">
            Features that you really love
        </div>
        <div className='features__cards'>
            {cards.map((card,index) => {
                return (
                    <div key={index} className='features__card'>
                        <div className='features__card-img'>
                            <img src={card.icon} alt={'feature-icon'}/>
                        </div>
                        <div className='features__card-title'>
                            {card.title}
                        </div>
                        <div className='features__card-text'>
                            {card.text}
                        </div>
                    </div>
                )
            })}
        </div>
      </div>
    </div>
  )
}
